export default __webpack_public_path__ + "static/media/nftArt3.2a32e731.png";